<template>
    <div class="modal" @click.stop="onClickBG">
        <div class="alert" @click.stop :style="{'max-width': maxWidth}">
            <div class="content">
                <slot name="content"></slot>
            </div>
            <slot name="list"></slot>
            <div class="buttons" :class="{'border': border}">
                <slot name="buttons"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PModal',
        props: {
            border: {
                default: true,
            },
            maxWidth: {
                default: '320px',
            }
        },
        methods: {
            onClickBG() {
                this.$emit('onClickBG');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .modal {
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.40);
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }

    .alert {
        width: 80%;
        max-height: 80%;
        background-color: white;
        border-radius: 10px;
        height: fit-content;
        overflow: auto;

        .content {
            padding: 20px;
        }

        .buttons {
            cursor: pointer;

            &.border {
                border-top: solid .5px rgba(221,221,221,1);
            }
        }
    }
</style>
